// import { BulbOutlined } from '@ant-design/icons';
// import { Fragment } from 'react';

// import antConfig from '@/ant-config';
// import { AppButton } from '@/react_app/components/Atoms';
// import Callout from '@/react_app/components/BillingUsage/Global/Callout';
// import { SmartUpgradeConfigurationProps } from '@/react_app/components/BillingUsage/Settings/settings-types';

// const SmartUpgradeConfiguration = ({
// 	isSmartUpgradeOn,
// 	onToggleSmartUpgradeState,
// 	isSmartUpgradeChangeLoading,
// }: SmartUpgradeConfigurationProps) => (
// 	<Callout
// 		className="max-w-6xl"
// 		title="Smart Upgrade"
// 		icon={<BulbOutlined />}
// 		actions={
// 			<AppButton
// 				style={{ color: 'white', backgroundColor: antConfig.token?.['purple-6'] }}
// 				type="primary"
// 				onClick={onToggleSmartUpgradeState}
// 				loading={isSmartUpgradeChangeLoading}
// 				disabled={isSmartUpgradeChangeLoading}
// 			>
// 				Turn {isSmartUpgradeOn ? 'off' : 'on'}
// 			</AppButton>
// 		}
// 	>
// 		<div className="leading-6">
// 			<div className="text-colorText text-[13px]">
// 				Smart upgrade is <strong>{isSmartUpgradeOn ? 'on' : 'off'}</strong>
// 			</div>
// 			{!isSmartUpgradeOn && (
// 				<Fragment>
// 					<div className="text-xs">Your features will stop working if you reach your plans’ limits.</div>
// 					<div className="text-xs">See smart upgrade history in usage history</div>
// 				</Fragment>
// 			)}
// 		</div>
// 	</Callout>
// );
const SmartUpgradeConfiguration = () => <div />;
export default SmartUpgradeConfiguration;
